import { axiosInstance } from '@src/configs/axios.configs';
import { IResponse } from '@src/interfaces/axios.interfaces';
import { IPaymentIntentData } from '@src/interfaces/payments.interfaces';

import {
  IMolliePaymentRequest,
  IPaymentCurrencyRequest,
  IPaymentCurrencyResponse,
  IPaymentIntentRequest,
  IResponseMolliePaymentMethods,
} from '../types/payment.types';
import {
  IExchangeToBaseRequest,
  IExchangeToBaseResponse,
} from '../types/user.types';

export const paymentService = {
  intent: ({
    reference,
    signal,
  }: IPaymentIntentRequest): IResponse<IPaymentIntentData> =>
    axiosInstance.get(`/api/payment/intent/${reference}`, { signal }),
  molliePaymentMethods: (
    params: IMolliePaymentRequest,
  ): IResponse<IResponseMolliePaymentMethods> =>
    axiosInstance(`api/payment/mollie/payment-methods`, { params }),
  currency: (
    params: IPaymentCurrencyRequest,
  ): IResponse<IPaymentCurrencyResponse> =>
    axiosInstance('api/users/currency', { params }),
  exchangeToBase: (
    params: IExchangeToBaseRequest,
  ): IResponse<IExchangeToBaseResponse> =>
    axiosInstance('api/payment/exchange/to-base', { params }),
};
